// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","logo":"header_logo__wLirW","whip":"header_whip__8M7Vb","navigation":"header_navigation__o+bEB"};